import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5480cd2f"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5480cd2f')) {
      api.createRecord('5480cd2f', component.options)
    } else {
      api.reload('5480cd2f', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5480cd2f", function () {
      api.rerender('5480cd2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/spu/package/view.vue"
export default component.exports